// Configurazione condivisa per le destinazioni e le loro immagini
export const destinationImages = {
  usa: ['usa.jpg', 'usa1.jpg', 'usa2.jpg', 'usa3.jpg'],
  canada: ['canada.jpg', 'canada1.jpg', 'canada2.jpg', 'canada3.jpg'],
  messico: ['messico1.jpg', 'mexico.jpg', 'messico2.jpg', 'messico3.jpg'],
  'america-centrale': ['americaCentrale.jpg', 'americaCentrale1.jpg', 'americaCentrale2.jpg', 'americaCentrale3.jpg'],
  'sud-america': ['sudamerica.jpg', 'sudamerica1.jpg', 'sudamerica2.jpg', 'sudamerica3.jpg'],
  caraibi: ['caraibi.jpg', 'caraibi1.jpg', 'caraibi2.jpg', 'caraibi3.jpg'],
  'polinesia-francese': ['polinesia.jpg', 'polinesia2.jpg', 'polinesia3.jpg', 'polinesia4.jpg', 'polinesia5.jpg']
};

export const destinations = [
  {
    name: 'USA',
    country: 'usa',
    description: 'Dai grattacieli di New York ai canyon dell\'Ovest, passando per strade leggendarie come la Route 66: gli Stati Uniti sono un viaggio tra natura estrema, cultura pop e città che non dormono mai.'
  },
  {
    name: 'Canada',
    country: 'canada',
    description: 'Paesaggi infiniti, laghi cristallini e le maestose Montagne Rocciose: il Canada è la meta perfetta per chi cerca avventura, natura incontaminata e città moderne immerse in scenari mozzafiato.'
  },
  {
    name: 'Messico',
    country: 'messico',
    description: 'Spiagge caraibiche, rovine Maya e tradizioni coloratissime: il Messico è un mix di storia millenaria, paesaggi da cartolina e cucina indimenticabile che conquista tutti i sensi.'
  },
  {
    name: 'America Centrale',
    country: 'america-centrale',
    description: 'Un mosaico di paesi pieni di energia: vulcani, foreste tropicali, spiagge spettacolari e città coloniali. L\'America Centrale è il cuore vibrante dell\'avventura latina, dove natura e cultura si fondono.'
  },
  {
    name: 'Sud America',
    country: 'sud-america',
    description: 'Dal ritmo del samba brasiliano alle cime andine, il Sud America è pura emozione: una terra di contrasti, colori intensi, paesaggi straordinari e popoli accoglienti che regalano esperienze indimenticabili.'
  },
  {
    name: 'Caraibi',
    country: 'caraibi',
    description: 'Mare turchese, spiagge di sabbia bianca e atmosfere rilassate: i Caraibi sono il sogno tropicale per eccellenza. Tra isole da esplorare, natura rigogliosa e cultura vivace, il relax è assicurato.'
  },
  {
    name: 'Polinesia Francese',
    country: 'polinesia-francese',
    description: 'Lagune turchesi, bungalow sull\'acqua e paesaggi da sogno: la Polinesia Francese è il paradiso terrestre, perfetto per chi cerca romanticismo, natura incontaminata e un\'esperienza indimenticabile in mezzo all\'Oceano Pacifico.'
  }
];
